import { GameDescription } from "../game-description";
import { Freecell } from "./freecell";
import { Klondike } from "./klondike";
import { Yukon } from "./yukon";

export const allGames: {[key: string]: GameDescription} = {
    'Klondike': Klondike,
    'Yukon': Yukon,
    'Freecell': Freecell
}